import { render } from "./AlienPlayerSummaryScoutReportForm.vue?vue&type=template&id=9ddc2db2"
import script from "./AlienPlayerSummaryScoutReportForm.vue?vue&type=script&lang=js"
export * from "./AlienPlayerSummaryScoutReportForm.vue?vue&type=script&lang=js"

import "./AlienPlayerSummaryScoutReportForm.vue?vue&type=style&index=0&id=9ddc2db2&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__